import { HelpLink } from 'elements/link/HelpLink'
import React from 'react'
import useTranslateParse from 'util/useTranslateParse'

export const UtilityTariffsDatabaseSubtitle = () => {
  const translateParse = useTranslateParse()
  return (
    <span>
      {translateParse(
        'Search our extensive database of utilities and rates. If there is a utility or rate missing from the database, please email the rate sheet to <mailtoLink>support@opensolar.com<mailtoLink>.',
        { mailtoLink: (label) => <a href="mailto:support@opensolar.com">{label}</a> }
      )}{' '}
      <HelpLink href="https://support.opensolar.com/hc/en-us/articles/12491593930895-How-OpenSolar-calculates-utility-bill-savings" />
    </span>
  )
}
